import { render } from "./SmallLoader.vue?vue&type=template&id=12c709e2&ts=true"
import script from "./SmallLoader.vue?vue&type=script&lang=ts"
export * from "./SmallLoader.vue?vue&type=script&lang=ts"

import "./SmallLoader.vue?vue&type=style&index=0&id=12c709e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__